module.exports = __webpack_public_path__ + "static/media/new-logo.04c763a1.png";